import $ from 'jquery';
import './slick.1.8.1.min';


function enableSlickCarousel() {
    $('.testimonials-carousel').slick({
        dots: true,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 2,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
        ]
    });
}


function loadWistiaOnVideoClick() {
    window._wq = window._wq || [];

    var wistiaPromise = undefined;

    function lazyloadWistia() {
        if (wistiaPromise == null) {
            wistiaPromise = $.getScript(
                '//fast.wistia.com/assets/external/E-v1.js',
                {'cache': false}
            );
        }
        return wistiaPromise;
    }

    function setLoading(element, enable) {
        element.closest('.loading')[enable ? 'addClass' : 'removeClass']('loading');
        element.find('.loading-icon')[enable ? 'show' : 'hide']();
        element.find('.play-button')[enable ? 'hide' : 'show']();
    }

    $('.testimonials-carousel a.poster-container[data-wistia-videoid]').each(function () {
        var jqLink = $(this);
        var videoId = jqLink.data('wistia-videoid');

        setLoading(jqLink, false);

        jqLink.on('click', function (e) {
            e.preventDefault();
            setLoading(jqLink, true);

            lazyloadWistia().done(function () {
                _wq.push({
                    id: videoId,
                    onReady: function (video) {
                        setLoading(jqLink, false);
                        video.bind('popoverhide', function () {
                            video.pause();
                        });
                        video.popover.show();
                        video.play();
                    }
                })
            })
        });
    });
}

window.addEventListener('DOMContentLoaded', function () {
    enableSlickCarousel();
    loadWistiaOnVideoClick();
});


